// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.provider-container-P9n7h {
  overflow-x: auto;
  padding: 0px 32px 20px;
}

.provider-toolbar-LQdFh {
  min-width: 800px;
  height: 56px;
  display: flex;
  gap: 32px;
  align-items: center;
  justify-content: flex-start;
}

.provider-title_container-pSzAb {
  width: 360px;
  flex-grow: 0;
  flex-shrink: 0;
}

.provider-title_title-h2fwC {
  font-size: 17px;
}

.provider-title_icon-kTWeT {
  --size: 20px;
}

.provider-tab_container-thAua, .provider-tab_container-thAua:first-of-type {
  cursor: pointer;
  padding: 0px;
}

.provider-tab_container-thAua:first-of-type {
  margin-left: 4px;
}

.provider-tab_container-thAua:not(:last-of-type) {
  margin-right: 48px;
}

.provider-tab_container-thAua:hover {
  background-color: unset;
}

.provider-tab_title-SY2gI {
  font-size: 15px;
  color: rgba(0, 0, 0, 0.9);
}

.provider-tab_indicator-h1uMd {
  border-radius: 2px;
  margin: 12px 2px 0px;
}

.provider-content-BJ3mY {
  display: flex;
  min-width: 800px;
  gap: 32px;
  margin-top: 0px;
}

.provider-outlineCard-S5r8q {
  width: 360px;
  flex-grow: 0;
  flex-shrink: 0;
  align-items: center;
}

.provider-image-xjfoJ {
  display: block;
  width: 80px;
  margin: 40px auto;
}

.provider-providerTitle-gTbTo {
  text-align: center;
  color: rgba(0, 0, 0, 0.8);
  font-size: 18px;
  font-weight: 500;
  padding-bottom: 40px;
}

.provider-detailItem_container-B3hwy, 
.provider-detailItemEnabled_container-GXDLJ, 
.provider-detailItemDisabled_container-xgkRm,
.provider-detailItemBalance_container-Dviqj {
  width: auto;
  margin: 0px 24px;
  padding: 20px 0px;
}

.provider-detailItem_title-hdEtX,
.provider-detailItemEnabled_title-XQf8A, 
.provider-detailItemDisabled_title-_w6g0,
.provider-detailItemBalance_title-v3KZ8 {
  font-size: 15px;
  font-weight: normal;
}

.provider-detailItem_text-ye9ta {
  font-weight: 500;
  font-size: 15px;
  color: rgba(0, 0, 0, 0.75);
}

.provider-detailItemEnabled_text-goVoC {
  color: var(--money-color);
  font-weight: 500;
}

.provider-detailItemDisabled_text-Ded9j {
  color: #333333;
  font-weight: 500;
}

.provider-detailItemBalance_text-nt3AR {
  color: var(--money-color);
  font-weight: 500;
}

.provider-outlineCardRight-fwF5p {
  height: auto;
  flex-grow: 1;
  overflow: auto;
}
`, "",{"version":3,"sources":["webpack://./src/pages/provider/provider.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;;;EAIE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;;;;EAIE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB","sourcesContent":[".container {\n  overflow-x: auto;\n  padding: 0px 32px 20px;\n}\n\n.toolbar {\n  min-width: 800px;\n  height: 56px;\n  display: flex;\n  gap: 32px;\n  align-items: center;\n  justify-content: flex-start;\n}\n\n.title_container {\n  width: 360px;\n  flex-grow: 0;\n  flex-shrink: 0;\n}\n\n.title_title {\n  font-size: 17px;\n}\n\n.title_icon {\n  --size: 20px;\n}\n\n.tab_container, .tab_container:first-of-type {\n  cursor: pointer;\n  padding: 0px;\n}\n\n.tab_container:first-of-type {\n  margin-left: 4px;\n}\n\n.tab_container:not(:last-of-type) {\n  margin-right: 48px;\n}\n\n.tab_container:hover {\n  background-color: unset;\n}\n\n.tab_title {\n  font-size: 15px;\n  color: rgba(0, 0, 0, 0.9);\n}\n\n.tab_indicator {\n  border-radius: 2px;\n  margin: 12px 2px 0px;\n}\n\n.content {\n  display: flex;\n  min-width: 800px;\n  gap: 32px;\n  margin-top: 0px;\n}\n\n.outlineCard {\n  width: 360px;\n  flex-grow: 0;\n  flex-shrink: 0;\n  align-items: center;\n}\n\n.image {\n  display: block;\n  width: 80px;\n  margin: 40px auto;\n}\n\n.providerTitle {\n  text-align: center;\n  color: rgba(0, 0, 0, 0.8);\n  font-size: 18px;\n  font-weight: 500;\n  padding-bottom: 40px;\n}\n\n.detailItem_container, \n.detailItemEnabled_container, \n.detailItemDisabled_container,\n.detailItemBalance_container {\n  width: auto;\n  margin: 0px 24px;\n  padding: 20px 0px;\n}\n\n.detailItem_title,\n.detailItemEnabled_title, \n.detailItemDisabled_title,\n.detailItemBalance_title {\n  font-size: 15px;\n  font-weight: normal;\n}\n\n.detailItem_text {\n  font-weight: 500;\n  font-size: 15px;\n  color: rgba(0, 0, 0, 0.75);\n}\n\n.detailItemEnabled_text {\n  color: var(--money-color);\n  font-weight: 500;\n}\n\n.detailItemDisabled_text {\n  color: #333333;\n  font-weight: 500;\n}\n\n.detailItemBalance_text {\n  color: var(--money-color);\n  font-weight: 500;\n}\n\n.outlineCardRight {\n  height: auto;\n  flex-grow: 1;\n  overflow: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `provider-container-P9n7h`,
	"toolbar": `provider-toolbar-LQdFh`,
	"title_container": `provider-title_container-pSzAb`,
	"title_title": `provider-title_title-h2fwC`,
	"title_icon": `provider-title_icon-kTWeT`,
	"tab_container": `provider-tab_container-thAua`,
	"tab_title": `provider-tab_title-SY2gI`,
	"tab_indicator": `provider-tab_indicator-h1uMd`,
	"content": `provider-content-BJ3mY`,
	"outlineCard": `provider-outlineCard-S5r8q`,
	"image": `provider-image-xjfoJ`,
	"providerTitle": `provider-providerTitle-gTbTo`,
	"detailItem_container": `provider-detailItem_container-B3hwy`,
	"detailItemEnabled_container": `provider-detailItemEnabled_container-GXDLJ`,
	"detailItemDisabled_container": `provider-detailItemDisabled_container-xgkRm`,
	"detailItemBalance_container": `provider-detailItemBalance_container-Dviqj`,
	"detailItem_title": `provider-detailItem_title-hdEtX`,
	"detailItemEnabled_title": `provider-detailItemEnabled_title-XQf8A`,
	"detailItemDisabled_title": `provider-detailItemDisabled_title-_w6g0`,
	"detailItemBalance_title": `provider-detailItemBalance_title-v3KZ8`,
	"detailItem_text": `provider-detailItem_text-ye9ta`,
	"detailItemEnabled_text": `provider-detailItemEnabled_text-goVoC`,
	"detailItemDisabled_text": `provider-detailItemDisabled_text-Ded9j`,
	"detailItemBalance_text": `provider-detailItemBalance_text-nt3AR`,
	"outlineCardRight": `provider-outlineCardRight-fwF5p`
};
export default ___CSS_LOADER_EXPORT___;
